//import { autoinject } from 'aurelia-framework';
//import { Redirect } from 'aurelia-router';

//import { AccountService } from '../shared/account-service';

//@autoinject
//export class IsAuthenticatedStep {

//  constructor(private accountService: AccountService) {
//  }

//  run(navigationInstruction: any, next: any) {
//    if (!this.accountService.isAuthenticated) {
//      if (navigationInstruction.getAllInstructions().some((i: any) => i.config.auth)) {
//        return next.cancel(new Redirect('login'));
//      }
//    }

//    return next();
//  }
//}
